import React from 'react'
import './styles/SelectContent.scss'
import Select from 'react-select'
import AsyncLoading from '../AsyncLoading/AsyncLoading'
import Option from './Option/Option'
import SingleValue from '../../components/SingleValue/SingleValue'
import DropdownIndicator from '../../components/DropdownIndicator/DropdownIndicator'
import ClearIndicator from './ClearIndicator/ClearIndicator'

const SelectContent = (props) => {
  const {
    options,
    onChange,
    onInputChange,
    onBlur,
    isLoading,
    noOptionsMessage,
    loadingMessage,
    placeholder,
    classNamePrefix,
  } = props

  return (
    <div className="selectContent">
      <Select
        className="reactSelect"
        classNamePrefix={classNamePrefix}
        options={options}
        onChange={onChange}
        onInputChange={onInputChange}
        onBlur={onBlur}
        isLoading={isLoading}
        filterOption={null}
        components={{
          LoadingIndicator: () => <AsyncLoading/>,
          DropdownIndicator,
          Option,
          SingleValue,
          ClearIndicator,
        }}
        noOptionsMessage={() => noOptionsMessage}
        loadingMessage={() => loadingMessage}
        placeholder={placeholder}
        openMenuOnClick={false}
        isClearable
      />
    </div>
  )
}

export default SelectContent
